'use client';

/**
 * Zone d'affichage des résultats de recherche
 *
 * Principe SOLID: Single Responsibility
 * - Responsable uniquement de l'orchestration de la zone résultats
 * - Délègue le rendu aux sous-composants
 *
 * @module EntityPagination
 */

import { useInstantSearch } from 'react-instantsearch';

import { PaginationWidget } from '@/app/(routes)/[locale]/(unauth)/recherche/components/pagination/PaginationWidget';

export function EntityPagination() {
  const { results } = useInstantSearch();

  // The `__isArtificial` flag makes sure not to display the No Results message
  // when no hits have been returned.
  if (!results.__isArtificial && results.nbHits === 0) {
    return null;
  }

  // Résultats + Pagination
  return (
    <div className="flex justify-center">
      <PaginationWidget />
    </div>
  );
}
